module.exports = __webpack_public_path__ + "static/media/new-event-12.ae86a91a.jpg";